import React from 'react';
import ReactDOM from 'react-dom';
import useScroll from 'scroll-behavior/lib/useStandardScroll';
import createStore from './redux/create';
import {Provider} from 'react-redux';
import { Router, useRouterHistory } from 'react-router'
import {Acl, User, UserProvider} from 'reactis-acl';
import immutable from 'immutable';
import getRoutes from './routes';
import config from './config';
import localstore from 'store';
import EventEmitter from "./EventEmitter";
import * as auth from './redux/modules/auth';
import * as Sentry from '@sentry/browser';

Sentry.init({dsn: "https://ca06119c850f466b860690e82902c3c0@sentry.reactis.cloud/2"});

//import Perf from 'react-addons-perf'
//window.Perf = Perf;

if (window._initState && window._initState.receipt) {
	window._initState.receipt = immutable.Map(window._initState.receipt);
}
const appHistory = useRouterHistory(useScroll(config.createHistory))();
const store = createStore(config.getApiClient, appHistory, window._initState);
window._store = store;
window.CSRF = window._initState.auth && window._initState.auth.csrf;
if (__MOBILE__) {
	window.XAuth = localstore.get('auth');
}

const acl = new Acl(window._initState && window._initState.auth && window._initState.auth.acl);
const user = new User(acl);
user.setRole(store.getState().auth.roles);
let currentAcl;
let currentRoles;
store.subscribe(() => {
	let prevAcl = currentAcl;
	let prevRoles = currentRoles;
	currentAcl = store.getState().auth.acl;
	currentRoles = store.getState().auth.roles;
	if (currentAcl != prevAcl) {
		user.setAcl(new Acl(store.getState().auth.acl));
	}
	if (currentRoles != prevRoles) {
		user.setRole(store.getState().auth.roles);
	}
});

const start = () => {
	ReactDOM.render(
		<Provider store={store} key="provider">
			<UserProvider user={user}>
				<Router history={appHistory}>
					{getRoutes(store)}
				</Router>
			</UserProvider>
		</Provider>, document.getElementById('app')
	);
};


if (__MOBILE__) {
	document.addEventListener('deviceready', () => {
		const token = localstore.get('fcm-token');
		if (!token) {
			window.FCMPlugin.getToken((token) => {
				localstore.set('fcm-token', token);
			});
		}

		window.FCMPlugin.onTokenRefresh((token) => {
			localstore.set('fcm-token', token);
			EventEmitter.emit('onPushNotificationNewToken', data);
		});

		window.FCMPlugin.onNotification((data) => {
			EventEmitter.emit('onPushNotification', data);
		});

		if (localstore.get('auth')) {
			store.dispatch(auth.init()).then(() => {
				start();
			});
		}
		else {
			start();
		}
	}, false);
}
else {
	start();
}

if (process.env.NODE_ENV !== 'production') {
	window.React = React; // enable debugger
}


// WEBPACK FOOTER //
// ./src/main.js